



















import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Route } from 'vue-router'
import store from '@/store'
import { createOnlineStatusConnection } from '@/websocket/utils/onlineStatus'
import WebRTCProvider from '@/webrtc'

@Component({
  components: {
    AppHeader: () => import('@/components/Header.vue'),
    CallModal: () => import('@/components/call/CallUserSelectModal.vue'),
    MessageModal: () => import('@/components/message/MessageModal.vue'),
    VideoCall: () => import('@/components/videoCallRoom/VideoCall.vue'),
    AlertModal: () => import('@/components/common/AlertModal.vue'),
    MessageReceiveModal: () =>
      import('@/components/common/MessageReceiveModal.vue')
  }
})
export default class Base extends Vue {
  $store!: ExStore

  blackout = false

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  async beforeRouteEnter(to: Route, from: Route, next: any) {
    try {
      await store.dispatch('user/updateUserInfo')
      const user = store.getters['user/userInfo']

      if (user.isPatient) {
        next({ name: 'PatientHome' })
        return
      }

      if (user.isPatientRelative) {
        next({ name: 'RelativeHome' })
        return
      }

      const change = 'PasswordChange'

      if (user.requireChangePassword && to.name !== change) {
        next({ name: change })
        return
      }

      next()
    } catch (e) {
      console.error(e)
      next()
    }
  }

  beforeCreate() {
    createOnlineStatusConnection()
  }

  async created() {
    this.$store.dispatch('ble/initialize')
    await Promise.all([
      this.$store.dispatch('message/updateUnreadHistory'),
      this.$store.dispatch('call/updateMissedHistory')
    ])
    this.attachWindowCloseEvent()
    this.$postMessage.emitVueDidLogin()
  }

  attachWindowCloseEvent() {
    window.addEventListener('unload', () => {
      WebRTCProvider.destroy()
    })
  }
}
